import React from 'react';
import PropTypes from 'prop-types'
import ActionButton from "../Atoms/Templates/ActionButton";
import SearchInput from "../Atoms/Forms/SearchInput";

const SearchInputButton = (props) => {
  const {id} = props

  return (
    <div className="search-input-button s-relative s-w-32px s-h-32px">
      <SearchInput
        className="s-absolute s-top-0 s-right-0 small"
        id={id}
      />
      <label
        className="s-relative"
        htmlFor={id}
      >
        <ActionButton
          className="s-to-right"
          icon="search"
        />
        {/* Contenedor invisible para que el botón pueda hacer focus al input */}
        <div className="s-mb-0 s-bg-red s-w-32px s-h-32px s-absolute s-top-0 s-left-0 s-right-0 cursor-pointer opacity-0"/>
      </label>
    </div>
  );
};

SearchInputButton.propTypes = {
  id: PropTypes.string.isRequired,
}

export default SearchInputButton;
